export const environment = {
  production: true,
  apiUrl: 'https://apicbbstore.cbb.cl/api/',
  version: '3.42.0',
  clarityProjectId: 'xdaxdp9iy7',
};
